export default __webpack_public_path__ + "static/media/CEDES-03.fd5bfd47.jpg";